export default __webpack_public_path__ + "static/new404-04b112a5cc8cecb6b03d6e6bcd81d49d.png";